import { useNavigate } from "react-router-dom";
import { AlertTriangle, ArrowLeft } from "lucide-react";

/**
 * Full-page notice shown in place of a disabled feature. Used for the
 * Bridge onramp (/setup-usbank) and offramp (/link-bank) pages, which
 * were taken offline as part of the wind-down.
 */
export default function FeatureUnavailable({ title }: { title: string }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#090D14] via-[#0A0E15] to-[#0B0F16] text-white flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full bg-gradient-to-br from-[#0F1419] to-[#1A1F2B] border border-gray-700/50 rounded-2xl sm:rounded-3xl p-6 sm:p-8 text-center shadow-xl shadow-black/30">
        <div className="mx-auto w-14 h-14 rounded-full bg-amber-500/10 border border-amber-500/30 flex items-center justify-center mb-5">
          <AlertTriangle className="text-amber-400" size={26} />
        </div>
        <h1 className="text-xl sm:text-2xl font-bold mb-2">{title}</h1>
        <p className="text-amber-400 font-semibold mb-2">
          Currently unavailable
        </p>
        <p className="text-gray-400 text-sm sm:text-base mb-7 leading-relaxed">
          This feature is currently unavailable. We apologize for any
          inconvenience.
        </p>
        <button
          onClick={() => navigate("/dashboard")}
          className="w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#61CE70] to-[#50B060] text-white py-3.5 rounded-xl sm:rounded-2xl font-medium hover:shadow-lg hover:shadow-[#61CE70]/30 transition-all text-sm sm:text-base"
        >
          <ArrowLeft size={18} />
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}
